// TEMP_BRIDGE
module.exports = require("./GlobalContext" + ".tsx");

